if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-gallery-step')) this.step(Number(button.dataset.galleryStep));
        else if (button.dataset.galleryTarget) this.setActiveMedia(button.dataset.galleryTarget);
        else if (button.hasAttribute('data-gallery-more')) {
          this.openLightbox(this.slides[4]?.dataset.rawMediaId, button);
        } else if (button.hasAttribute('data-gallery-close')) this.dialog.close();
        else if (button.hasAttribute('data-lightbox-step')) this.stepLightbox(Number(button.dataset.lightboxStep));
      });
      this.addEventListener('click', (event) => {
        const opener = event.target.closest('.product__modal-opener--image');
        if (!opener) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const slide = opener.closest('[data-raw-media-id]');
        this.openLightbox(slide.dataset.rawMediaId, opener.querySelector('button'));
      }, true);
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog?.addEventListener('close', () => {
        window.pauseAllMedia?.();
        document.body.style.overflow = this.previousOverflow;
        this.opener?.focus();
      });
      this.dialog?.addEventListener('keydown', (event) => {
        if (event.target.matches('video, iframe, input, textarea')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.stepLightbox(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      const viewer = this.querySelector('.nomads-gallery__viewer');
      let start;
      viewer?.addEventListener('touchstart', (event) => {
        start = {x:event.touches[0].clientX,y:event.touches[0].clientY};
      }, {passive:true});
      viewer?.addEventListener('touchend', (event) => {
        if (!start) return;
        const dx=event.changedTouches[0].clientX-start.x,dy=event.changedTouches[0].clientY-start.y;
        if (Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)) this.step(dx<0?1:-1);
        start=null;
      }, {passive:true});
      this.setActiveMedia(this.slides.find(slide=>slide.classList.contains('is-active'))?.dataset.mediaId);
    }
    get slides() { return Array.from(this.querySelectorAll('.nomads-gallery__slides > [data-media-id]')); }
    setActiveMedia(mediaId) {
      const active = this.slides.find(slide=>slide.dataset.mediaId===mediaId) || this.slides[0];
      if (!active) return;
      window.pauseAllMedia?.();
      const index = this.slides.indexOf(active);
      [active, this.slides[(index+1)%this.slides.length], this.slides[(index-1+this.slides.length)%this.slides.length]].forEach(slide=>{
        slide?.querySelectorAll('img').forEach(img=>{img.loading='eager';});
      });
      this.slides.forEach(slide=>slide.classList.toggle('is-active',slide===active));
      this.querySelectorAll('[data-gallery-target]').forEach(button=>{
        if (button.dataset.galleryTarget===active.dataset.mediaId) button.setAttribute('aria-current','true');
        else button.removeAttribute('aria-current');
      });
      const status=this.querySelector('[role="status"]');
      if(status) status.textContent='Média '+(this.slides.indexOf(active)+1)+' sur '+this.slides.length;
    }
    step(direction) {
      const index=this.slides.findIndex(slide=>slide.classList.contains('is-active'));
      this.setActiveMedia(this.slides[(index+direction+this.slides.length)%this.slides.length]?.dataset.mediaId);
    }
    get lightboxItems() { return Array.from(this.querySelectorAll('[data-lightbox-media]')); }
    openLightbox(mediaId, opener) {
      if (!this.dialog || !this.lightboxItems.length) return;
      this.opener=opener;
      this.previousOverflow=document.body.style.overflow;
      document.body.style.overflow='hidden';
      this.showLightboxItem(mediaId);
      this.dialog.showModal();
      this.querySelector('[data-gallery-close]').focus();
    }
    showLightboxItem(mediaId) {
      const active=this.lightboxItems.find(item=>item.dataset.lightboxMedia===mediaId)||this.lightboxItems[0];
      window.pauseAllMedia?.();
      this.lightboxItems.forEach(item=>item.classList.toggle('is-active',item===active));
      this.querySelector('.nomads-gallery__counter').textContent=(this.lightboxItems.indexOf(active)+1)+' / '+this.lightboxItems.length;
    }
    stepLightbox(direction) {
      const index=this.lightboxItems.findIndex(item=>item.classList.contains('is-active'));
      this.showLightboxItem(this.lightboxItems[(index+direction+this.lightboxItems.length)%this.lightboxItems.length]?.dataset.lightboxMedia);
    }
  });
}
